require('moment/moment.js');
require('moment/locale/nl.js');
require('pc-bootstrap4-datetimepicker/src/js/bootstrap-datetimepicker.js');

import moment from 'moment';

moment.updateLocale('nl', {
    longDateFormat : {
        L: "DD/MM/YYYY",
        l: "D/M/YYYY"
    }
});

jQuery.extend(true, jQuery.fn.datetimepicker.defaults, {
    locale: 'nl',
    format: 'DD/MM/YYYY',
    icons: {
        time: 'far fa-clock',
        date: 'far fa-calendar',
        up: 'fas fa-arrow-up',
        down: 'fas fa-arrow-down',
        previous: 'fas fa-chevron-left',
        next: 'fas fa-chevron-right',
        today: 'fas fa-calendar-check',
        clear: 'far fa-trash-alt',
        close: 'far fa-times-circle'
    },

});
